import { ReactNode } from 'react';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import styles from './Tooltip.module.css';

interface TooltipProps {
  center: ReactNode
  right?: ReactNode
  placement?: 'top' | 'bottom'
  className?: string
  children: ReactNode
}

function Tooltip({
  center,
  right,
  placement = 'bottom',
  className,
  children,
}: TooltipProps) {
  return (
    <Tippy
      animation="scale"
      duration={[100, 0]}
      placement={placement}
      content={(
        <div className={styles.tooltip}>
          <div className={styles.center}>{center}</div>
          {right && (
            <>
              <span className={styles.rightDot}>•</span>
              <div className={styles.right}>{right}</div>
            </>
          )}
        </div>
      )}
    >
      <div className={classNames(className, styles.cursor)}>{children}</div>
    </Tippy>
  );
}

Tooltip.defaultProps = {
  right: undefined,
  className: undefined,
  placement: undefined,
};

export default Tooltip;
